import React, { useState } from 'react';
import {Box, Typography, Paper, Button, Radio, RadioGroup, FormControlLabel, TextField, IconButton, FormControl } from '@mui/material';
import { Visibility, VisibilityOff, InfoOutlined } from "@mui/icons-material";
import { useThemeContext } from '../../context/ThemeContext';
import axios from 'axios';


const tabs = ['Preferences', 'Notification', 'Privacy & Feedback', 'General Info'];

const SettingsPage = () => {
  const [selectedTab, setSelectedTab] = useState('Preferences');
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [notificationTiming, setNotificationTiming] = useState("always");
  const [startHour, setStartHour] = useState('00');
  const [startMinute, setStartMinute] = useState('00');
  const [endHour, setEndHour] = useState('00');
  const [endMinute, setEndMinute] = useState('00');
  const { themeMode, updateTheme } = useThemeContext();


  const handleSaveNotificationTime = async () => {
    try {
      const start_time = `${startHour}:${startMinute}:00`;
      const end_time = `${endHour}:${endMinute}:00`;
  
      const payload = {
        notification_start_time: start_time,
        notification_end_time: end_time,
      };
  
      console.log("Payload being sent:", payload);

      await axios.put('http://127.0.0.1:8000/settings/notification1/1', payload); 
  
      alert("Notification time saved successfully!");

    } catch (error) {
      console.error("Error saving notification time:", error);
      alert("Failed to save notification time.");
    }
  };

  const handleStartHourChange = (value) => {
    const val = Math.min(23, Math.max(0, parseInt(value) || 0));
    setStartHour(val.toString().padStart(2, '0'));
  };  

  const handleStartMinuteChange = (value) => {
    const val = Math.min(59, Math.max(0, parseInt(value) || 0));
    setStartMinute(val.toString().padStart(2, '0'));
  };

  const handleEndHourChange = (value) => {
    const val = Math.min(23, Math.max(0, parseInt(value) || 0));
    setEndHour(val.toString().padStart(2, '0'));
  };  

  const handleEndMinuteChange = (value) => {
    const val = Math.min(59, Math.max(0, parseInt(value) || 0));
    setEndMinute(val.toString().padStart(2, '0'));
  };

  const tabsContent = () => {
    switch (selectedTab) {
      case 'Preferences':
        return (
          <>
            <Box display="flex" justifyContent="center" mb={2}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#F4A600',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '20px',
                  px: 3,
                  '&:hover': { backgroundColor: '#e39600' },
                }}
              >
                Upgrade to premium
              </Button>
            </Box>

            <Typography fontWeight={600} mb={1}>
              Theme
            </Typography>
            <RadioGroup 
            row
            value={themeMode}
            onChange={(e) => updateTheme(e.target.value)}
            >
              <FormControlLabel value="system" control={<Radio />} label="System Default" />
              <FormControlLabel value="light" control={<Radio />} label="Light" />
              <FormControlLabel value="dark" control={<Radio />} label="Dark" />
            </RadioGroup>

            <Box display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
              <Typography fontWeight={600}>Change password</Typography>
              <Typography
                sx={{
                  color: showPasswordForm ? "red" : "#0050FF",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onClick={() => setShowPasswordForm(!showPasswordForm)}
              >
                {showPasswordForm ? "Cancel" : "Change"}
              </Typography>
            </Box>

            {showPasswordForm && (
              <Box
                sx={{
                  border: '1px solid #ddd',
                  borderRadius: '16px',
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                {[
                  { label: "Old password", show: showOldPassword, setShow: setShowOldPassword },
                  { label: "New password", show: showNewPassword, setShow: setShowNewPassword },
                  { label: "Confirm new password", show: showConfirmPassword, setShow: setShowConfirmPassword },
                ].map((item, index) => (
                  <Box key={index}>
                    <Typography fontWeight={600} mb={0.5}>{item.label}</Typography>
                    <Box
                      sx={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '12px',
                        px: 2,
                        py: 1,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <TextField
                        fullWidth
                        type={item.show ? "text" : "password"}
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                      />
                      <IconButton onClick={() => item.setShow(!item.show)}>
                        {item.show ?  <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </Box>
                  </Box>
                ))}

                <Box display="flex" justifyContent="flex-end" mt={1}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#0050FF",
                      color: "#fff",
                      textTransform: "none",
                      borderRadius: "20px",
                      px: 4,
                      '&:hover': { backgroundColor: "#0040d4" },
                    }}
                  >
                    Update
                  </Button>
                </Box>
              </Box>
            )}
            {/* <Box
              sx={{
                border: '1px solid #ddd',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                px: 2,
                py: 1,
              }}
            >
              <TextField
                variant="standard"
                type="password"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value="********"
              />
              <IconButton>
                <Visibility />
              </IconButton>
            </Box> */}
          </>
        );

        case 'Notification':
          return (
            <Box sx={{ mt: 2 }}>
              <h3 fontWeight={600} mb={2}>
                Restrict notification timing
              </h3>
        
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  value={notificationTiming}
                  onChange={(e) => setNotificationTiming(e.target.value)}
                >
                  <FormControlLabel value="always" control={<Radio />} label="Always" />
                  <FormControlLabel value="set-time" control={<Radio />} label="Set time" />
                </RadioGroup>
              </FormControl>
        
              {notificationTiming === 'set-time' && (
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    border: '1px solid #e0e0e0',
                    borderRadius: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <InfoOutlined fontSize="small" sx={{ color: '#999' }} />
                    <Typography variant="body2" color="#999">
                      You will receive notification in the time range selected.
                    </Typography>
                  </Box>
        
                  <Box display="flex" alignItems="center" gap={1}>
                    {/* From Time */}
                    <Box>
                      <Typography variant="body2" fontWeight={500}>Hour</Typography>
                      <TextField
                        type="number"
                        size="small"
                        value={startHour}
                        onChange={(e) => handleStartHourChange(e.target.value)}
                        inputProps={{
                          min: 0,
                          max: 23,
                          step: 1,
                        }}
                        sx={{ width: 70 }}
                      />
                    </Box>
                    <Box>
                      <Typography variant="body2" fontWeight={500}>Minutes</Typography>
                      <TextField
                        type="number"
                        size="small"
                        value={startMinute}
                        onChange={(e) => handleStartMinuteChange(e.target.value)}
                        inputProps={{
                          min: 0,
                          max: 59,
                          step: 1,
                        }}
                        sx={{ width: 70 }}
                      />
                    </Box>
        
                    <Typography variant="body2" fontWeight={600}>TO</Typography>
        
                    {/* To Time */}
                    <Box>
                      <Typography variant="body2" fontWeight={500}>Hour</Typography>
                      <TextField
                        type="number"
                        size="small"
                        value={endHour}
                        onChange={(e) => handleEndHourChange(e.target.value)}
                        inputProps={{
                          min: 0,
                          max: 23,
                          step: 1,
                        }}
                        sx={{ width: 70 }}
                      />
                    </Box>
                    <Box>
                      <Typography variant="body2" fontWeight={500}>Minutes</Typography>
                      <TextField
                        type="number"
                        size="small"
                        value={endMinute}
                        onChange={(e) => handleEndMinuteChange(e.target.value)}
                        inputProps={{
                          min: 0,
                          max: 59,
                          step: 1,
                        }}
                        sx={{ width: 70 }}
                      />
                    </Box>
                  </Box>
        
                  <Box display="flex" gap={2}>
                    <Button
                      variant="outlined"
                      sx={{
                        borderRadius: '20px',
                        textTransform: 'none',
                      }}
                      onClick={() => {
                        setStartHour('00');
                        setStartMinute('00');
                        setEndHour('00');
                        setEndMinute('00');
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: '#0050FF',
                        color: '#fff',
                        borderRadius: '20px',
                        textTransform: 'none',
                        '&:hover': { backgroundColor: '#0040d4' },
                      }}
                      onClick={handleSaveNotificationTime}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          );
        
      case 'Privacy & Feedback':
        return (
          <>
            <h3 fontWeight={600}>
              Privacy and feedback details
            </h3>
          </>
        );

      case 'General Info':
        return (
          <>
            <h3 fontWeight={600} mb={2}>
              General Info
            </h3>

            <h4 fontWeight={500} color="black" >
              About Us
            </h4>
            <Typography mb={2}>
              We are a Bill tracking Management Platform
            </Typography>

            <h4 fontWeight={500} color="black" >
              Webapp Version
            </h4>
            <Typography>2.2</Typography>
          </>
        );

      default:
        return <Typography>This is {selectedTab} content.</Typography>;
    }
  };

  return (
    <Box sx={{ mt: 10, px: 2, minHeight: "100vh"  }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, sm: 3, md: 4  },
          m: { xs: 1, sm: 2 },
          borderRadius: 3,
          background: "#fff",
        }}
      >
        <Typography variant="h5" fontWeight={600} mb={3}>
          Settings
        </Typography>

        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "flex-start" }}
          gap={4}
        >
          <Box
            sx={{
              width: { xs: "100%", sm: "220px" },
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {tabs.map((tab) => (
              <Box
                key={tab}
                onClick={() => setSelectedTab(tab)}
                sx={{
                  backgroundColor: selectedTab === tab ? "#0050FF" : "#F4F6FB",
                  color: selectedTab === tab ? "#fff" : "#333",
                  fontWeight: 600,
                  px: 2,
                  py: 1.5,
                  borderRadius: "12px",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
              >
                {tab}
              </Box>
            ))}
          </Box>

          {/* Tab Content Box */}
          <Box
            flex={1}
            sx={{
              maxWidth: { xs: "100%", sm: "50%" },  
              margin: "0 auto",
              backgroundColor: "#fff",
              border: "1px solid #ececed",
              borderRadius: "20px",
              p: 3,
            }}
          >
            {tabsContent()}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default SettingsPage;
